export const styles = `
:host, .overlay-root {
  font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, Inter, system-ui, sans-serif;
  color: #eceef2;
  font-size: 13px;
  line-height: 1.5;
}
.overlay-root * { box-sizing: border-box; }
.overlay-root button { font: inherit; color: inherit; background: transparent; border: 0; cursor: pointer; }
.overlay-root input, .overlay-root select, .overlay-root textarea { font: inherit; color: inherit; }
.overlay-root code, .overlay-root pre { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }

/* ---------- Sidebar shell ---------- */
.sidebar {
  position: fixed;
  pointer-events: auto;
  background: rgba(10, 12, 18, 0.94);
  backdrop-filter: blur(14px);
  display: flex; flex-direction: column;
  transition: transform 180ms ease;
}
.sidebar.dock-left {
  left: 0; top: 0; bottom: 0;
  width: 380px;
  border-right: 1px solid rgba(255,255,255,0.08);
  box-shadow: 20px 0 60px -20px rgba(0,0,0,0.6);
}
.sidebar.dock-left.collapsed { transform: translateX(-100%); }
.sidebar.dock-right {
  right: 0; top: 0; bottom: 0;
  width: 380px;
  border-left: 1px solid rgba(255,255,255,0.08);
  box-shadow: -20px 0 60px -20px rgba(0,0,0,0.6);
}
.sidebar.dock-right.collapsed { transform: translateX(100%); }
.sidebar.dock-top {
  top: 0; left: 0; right: 0;
  height: 360px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  box-shadow: 0 20px 60px -20px rgba(0,0,0,0.6);
}
.sidebar.dock-top.collapsed { transform: translateY(-100%); }
.sidebar.dock-bottom {
  bottom: 0; left: 0; right: 0;
  height: 360px;
  border-top: 1px solid rgba(255,255,255,0.08);
  box-shadow: 0 -20px 60px -20px rgba(0,0,0,0.6);
}
.sidebar.dock-bottom.collapsed { transform: translateY(100%); }

.dock-picker { display: flex; gap: 2px; padding: 2px; border: 1px solid rgba(255,255,255,0.08); border-radius: 7px; background: rgba(255,255,255,0.04); }
.dock-picker button {
  width: 22px; height: 22px; border-radius: 5px;
  display: inline-flex; align-items: center; justify-content: center;
  color: #8b93a5; font-size: 12px; line-height: 1;
}
.dock-picker button:hover { color: #eceef2; background: rgba(255,255,255,0.06); }
.dock-picker button.active { background: rgba(155,140,255,0.22); color: #eceef2; }

.sidebar-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 14px; border-bottom: 1px solid rgba(255,255,255,0.06);
}
.brand { display: flex; align-items: center; gap: 8px; font-weight: 600; letter-spacing: -0.01em; }
.brand .dot {
  width: 16px; height: 16px; border-radius: 5px;
  background: linear-gradient(135deg, #9b8cff, #5b46f0);
  box-shadow: 0 0 0 1px rgba(255,255,255,0.12) inset;
}
.muted { color: #8b93a5; }
.tag {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.08em;
  color: #8b93a5; padding: 2px 6px; border: 1px solid rgba(255,255,255,0.08);
  border-radius: 6px; font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

/* ---------- Tabs ---------- */
.tabs {
  display: flex; gap: 2px; padding: 6px 8px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.02);
}
.tab {
  flex: 1; padding: 7px 10px; border-radius: 7px;
  font-size: 12px; font-weight: 500; color: #8b93a5;
  display: flex; align-items: center; justify-content: center; gap: 6px;
}
.tab:hover { color: #eceef2; background: rgba(255,255,255,0.03); }
.tab.active { color: #eceef2; background: rgba(155,140,255,0.14); }
.tab .count {
  font-size: 10px; padding: 1px 5px; border-radius: 5px;
  background: rgba(155,140,255,0.25); color: #eceef2;
}

/* ---------- Body ---------- */
.sidebar-header, .tabs, .footer-bar { flex-shrink: 0; }
.sidebar-body {
  flex: 1 1 0; min-height: 0;
  overflow-y: auto; overflow-x: hidden;
  padding: 12px;
  display: flex; flex-direction: column; gap: 12px;
}
.sidebar-body > * { flex-shrink: 0; }

/* ---------- Inspect layout ---------- */
.inspect-pane {
  flex: 1 1 0; min-height: 0;
  display: flex; flex-direction: column;
  padding: 12px 12px 0;
  gap: 10px;
}
.inspect-pane .inspect-context { flex-shrink: 0; }
.inspect-scroll {
  flex: 1 1 0; min-height: 0;
  overflow-y: auto; overflow-x: hidden;
  display: flex; flex-direction: column; gap: 10px;
  position: relative;
  padding-right: 2px;
}
.inspect-scroll > * { flex-shrink: 0; }
.inspect-commit-slot {
  flex-shrink: 0;
  padding: 10px 0 12px;
  border-top: 1px solid rgba(255,255,255,0.08);
  background: rgba(10,12,18,0.96);
}
.empty-state {
  display: flex; flex-direction: column; gap: 10px;
  align-items: center; justify-content: center;
  padding: 40px 16px; text-align: center;
  color: #8b93a5; font-size: 12px;
}
.empty-state .icon {
  width: 44px; height: 44px; border-radius: 12px;
  background: rgba(155,140,255,0.12); display: flex; align-items: center; justify-content: center;
  font-size: 20px;
}

/* ---------- Selection card ---------- */
.selection-card, .card {
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.03);
  border-radius: 10px;
  padding: 10px;
}
.selection-card .sel {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11px; color: #9b8cff; word-break: break-all;
}
.selection-card .preview {
  margin-top: 6px; font-size: 12px; color: #d3d8e1;
  max-height: 60px; overflow: hidden; text-overflow: ellipsis;
  display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;
}

/* ---------- Chat composer ---------- */
.prompt {
  width: 100%; resize: vertical;
  min-height: 80px; max-height: 200px;
  padding: 10px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 10px;
  color: #eceef2; font: inherit;
  outline: none;
}
.prompt:focus { border-color: rgba(155,140,255,0.5); box-shadow: 0 0 0 3px rgba(123,102,255,0.18); }

.row { display: flex; gap: 8px; align-items: center; }
.row .spacer { flex: 1; }

.btn {
  padding: 7px 12px; border-radius: 8px; font-size: 12px; font-weight: 500;
  border: 1px solid rgba(255,255,255,0.1);
  background: rgba(255,255,255,0.04);
  transition: 120ms;
}
.btn:hover { border-color: rgba(255,255,255,0.2); background: rgba(255,255,255,0.07); }
.btn.primary { background: #fff; color: #0a0c12; border-color: transparent; }
.btn.primary:hover { background: #eceef2; }
.btn.accent { background: #7a66ff; color: #fff; border-color: transparent; }
.btn.accent:hover { background: #5b46f0; }
.btn[disabled] { opacity: 0.5; cursor: not-allowed; }
.btn.ghost { padding: 4px 8px; font-size: 11px; }

/* ---------- Op cards ---------- */
.op {
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.03);
  border-radius: 8px; padding: 8px; font-size: 12px;
}
.op .type { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; color: #9b8cff; font-size: 11px; }
.op .diff .before { color: #8b93a5; text-decoration: line-through; }
.op .diff .after { color: #eceef2; }
.op .rationale { color: #8b93a5; font-size: 11px; margin-top: 4px; }

/* ---------- Inspect panel ---------- */
.inspect-section {
  border: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.02);
  border-radius: 10px;
  overflow: hidden;
}
.inspect-section-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 10px; font-size: 11px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.06em; color: #b3b9c9;
  background: rgba(255,255,255,0.02);
  border-bottom: 1px solid rgba(255,255,255,0.05);
}
.inspect-section-body { padding: 10px; display: flex; flex-direction: column; gap: 10px; }

.field { display: flex; flex-direction: column; gap: 4px; }
.field label { font-size: 11px; color: #8b93a5; }
.field-inline { display: flex; align-items: center; gap: 8px; }
.field-inline label { flex: 0 0 72px; font-size: 11px; color: #8b93a5; }

.input, .select {
  width: 100%;
  padding: 6px 8px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 7px;
  color: #eceef2; font-size: 12px;
  outline: none;
}
.input:focus, .select:focus { border-color: rgba(155,140,255,0.5); }
.input.mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 11px; }

.color-swatch {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 4px; border: 1px solid rgba(255,255,255,0.08);
  border-radius: 7px; background: rgba(255,255,255,0.04);
}
.color-swatch input[type="color"] {
  width: 26px; height: 22px; border: 0; padding: 0; background: transparent; cursor: pointer;
}
.color-swatch input[type="text"] {
  background: transparent; border: 0; outline: none; color: #eceef2;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 11px; width: 72px;
}

.grid-4 {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 6px;
}
.grid-2 {
  display: grid; grid-template-columns: repeat(2, 1fr); gap: 6px;
}

.seg {
  display: flex; gap: 2px; padding: 2px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 7px;
}
.seg button {
  flex: 1; padding: 4px 6px; border-radius: 5px;
  font-size: 11px; color: #8b93a5;
}
.seg button.active { background: rgba(155,140,255,0.18); color: #eceef2; }
.seg button:hover:not(.active) { color: #eceef2; }

.slider-row { display: flex; align-items: center; gap: 8px; }
.slider-row input[type="range"] { flex: 1; }
.slider-row .value { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 11px; color: #b3b9c9; min-width: 40px; text-align: right; }

.commit-bar {
  position: sticky; bottom: 0;
  margin: 0;
  padding: 10px;
  background: rgba(10,12,18,0.96);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 10px;
  display: flex; gap: 8px; align-items: center;
}

/* ---------- Code tab ---------- */
.code-pane {
  flex: 1 1 0; min-height: 0;
  display: flex; flex-direction: column;
  gap: 10px; padding: 12px 12px 0;
}
.code-context { flex-shrink: 0; }
.code-editor-wrap {
  flex: 1 1 0; min-height: 0;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 10px;
  overflow: hidden;
  background: #1e1e1e;
}
.code-editor { width: 100%; height: 100%; }
.code-commit {
  flex-shrink: 0;
  padding: 10px 0 12px;
  display: flex; gap: 8px; align-items: center;
  border-top: 1px solid rgba(255,255,255,0.06);
}

/* ---------- Picker ---------- */
.pick-button {
  padding: 10px 14px; border-radius: 12px;
  background: rgba(10,12,18,0.9); border: 1px solid rgba(255,255,255,0.1);
  color: #eceef2; font-size: 13px; font-weight: 500;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,0.5);
  display: inline-flex; align-items: center; gap: 10px; cursor: pointer;
}
.pick-button .dot { width: 10px; height: 10px; border-radius: 50%; background: #7a66ff; box-shadow: 0 0 12px #7a66ff; }

.picker-overlay {
  position: fixed; inset: 0; pointer-events: none;
  background: rgba(6,7,12,0.15);
}
.picker-hint {
  position: fixed; top: 16px; left: 50%; transform: translateX(-50%);
  background: rgba(10,12,18,0.95); border: 1px solid rgba(255,255,255,0.1);
  padding: 8px 12px; border-radius: 10px; font-size: 12px; color: #eceef2;
  pointer-events: none;
}

/* ---------- Collapsed launcher tab ---------- */
.launcher-tab {
  position: fixed;
  pointer-events: auto;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  padding: 10px 6px;
  background: rgba(10,12,18,0.92);
  border: 1px solid rgba(255,255,255,0.08);
  cursor: pointer; color: #eceef2;
}
.launcher-tab:hover { background: rgba(10,12,18,0.98); }
.launcher-tab.dock-left { left: 0; top: 50%; transform: translateY(-50%); flex-direction: column; border-left: 0; border-radius: 0 10px 10px 0; }
.launcher-tab.dock-right { right: 0; top: 50%; transform: translateY(-50%); flex-direction: column; border-right: 0; border-radius: 10px 0 0 10px; }
.launcher-tab.dock-top { top: 0; left: 50%; transform: translateX(-50%); border-top: 0; border-radius: 0 0 10px 10px; }
.launcher-tab.dock-bottom { bottom: 0; left: 50%; transform: translateX(-50%); border-bottom: 0; border-radius: 10px 10px 0 0; }
.launcher-tab .v-label {
  font-size: 11px; letter-spacing: 0.1em; text-transform: uppercase;
}
.launcher-tab.dock-left .v-label,
.launcher-tab.dock-right .v-label {
  writing-mode: vertical-rl; transform: rotate(180deg);
}

/* ---------- Chat layout ---------- */
.chat-pane {
  flex: 1; min-height: 0;
  display: flex; flex-direction: column;
  gap: 10px;
  padding: 10px 12px 0;
}
.chat-context { flex-shrink: 0; }
.context-pill {
  display: flex; align-items: center; gap: 8px;
  padding: 6px 8px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 8px;
  font-size: 11px;
}
.context-pill .sel {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  color: #9b8cff; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  max-width: 160px;
}
.context-pill.locked { border-color: rgba(255,180,100,0.35); background: rgba(255,180,100,0.06); }
.context-pill.locked .sel { color: #ffc989; }

.lock-list {
  flex-shrink: 0;
  border: 1px solid rgba(255,180,100,0.22);
  background: rgba(255,180,100,0.05);
  border-radius: 8px;
  padding: 6px 8px;
  display: flex; flex-direction: column; gap: 4px;
  font-size: 11px;
}
.lock-list .head { color: #ffc989; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; font-size: 10px; }
.lock-list .item {
  display: flex; align-items: center; gap: 6px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  color: #d3d8e1;
}
.lock-list .item .sel { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.chat-messages {
  flex: 1; min-height: 0;
  overflow-y: auto;
  display: flex; flex-direction: column;
  gap: 10px;
  padding: 2px;
}
.msg { display: flex; flex-direction: column; gap: 4px; max-width: 100%; }
.msg.user { align-items: flex-end; }
.msg.user .bubble {
  background: rgba(155,140,255,0.18);
  border: 1px solid rgba(155,140,255,0.3);
  color: #eceef2;
  padding: 8px 10px; border-radius: 12px 12px 2px 12px;
  font-size: 12px; line-height: 1.5;
  max-width: 88%;
}
.msg.user .meta { font-size: 10px; color: #8b93a5; padding-right: 4px; }
.msg.assistant .bubble {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.08);
  color: #d3d8e1;
  padding: 10px; border-radius: 12px 12px 12px 2px;
  font-size: 12px; line-height: 1.5;
}

.chat-composer {
  flex-shrink: 0;
  display: flex; flex-direction: column; gap: 6px;
  padding: 10px 0 12px;
  border-top: 1px solid rgba(255,255,255,0.06);
  background: linear-gradient(to top, rgba(10,12,18,1) 70%, rgba(10,12,18,0.4));
  position: sticky; bottom: 0;
}
.chat-composer .prompt { min-height: 60px; max-height: 160px; }

/* ---------- Status / errors / footer ---------- */
.status { display: flex; align-items: center; gap: 6px; font-size: 11px; color: #8b93a5; }
.status .pulse { width: 8px; height: 8px; border-radius: 50%; background: #9b8cff; animation: pulse 1s ease-in-out infinite; }
@keyframes pulse { 0%, 100% { opacity: 1 } 50% { opacity: 0.3 } }
.error { color: #ff9d9d; font-size: 12px; }

.footer-bar {
  padding: 8px 12px; border-top: 1px solid rgba(255,255,255,0.06);
  display: flex; justify-content: space-between; align-items: center;
  font-size: 11px; color: #8b93a5;
}

/* ---------- Asset picker ---------- */
.asset-picker {
  position: absolute; inset: 0;
  background: #0a0c12; border-left: 1px solid rgba(255,255,255,0.08);
  display: flex; flex-direction: column; z-index: 2;
  pointer-events: auto;
}
.asset-picker-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 14px; border-bottom: 1px solid rgba(255,255,255,0.06);
}
.asset-picker-title { font-weight: 600; font-size: 13px; }
.icon-btn {
  width: 28px; height: 28px; border-radius: 6px;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 18px; color: #8b93a5;
}
.icon-btn:hover { background: rgba(255,255,255,0.06); color: #eceef2; }
.asset-picker-actions {
  display: flex; align-items: center; gap: 10px;
  padding: 12px 14px; border-bottom: 1px solid rgba(255,255,255,0.04);
}
.asset-picker-error {
  margin: 10px 14px 0; padding: 8px 10px; border-radius: 6px;
  background: rgba(255,100,100,0.08); color: #ff9d9d; font-size: 12px;
}
.asset-picker-section {
  padding: 12px 14px; border-bottom: 1px solid rgba(255,255,255,0.04);
  overflow: auto;
}
.asset-picker-section:last-child { border-bottom: 0; flex: 1; min-height: 0; }
.asset-picker-section-label {
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em;
  color: #8b93a5; margin-bottom: 8px;
}
.asset-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px;
}
.asset-tile {
  position: relative; padding: 0; border-radius: 6px; overflow: hidden;
  aspect-ratio: 1; background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.06);
  transition: border-color .15s, transform .15s;
}
.asset-tile:hover { border-color: #7a66ff; transform: translateY(-1px); }
.asset-tile img { width: 100%; height: 100%; object-fit: cover; display: block; }
`;
